var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 57,
    viewBox: "0 0 59 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5 0C45.2401 0 58 12.7599 58 28.5C58 44.2401 45.2401 57 29.5 57C13.7599 57 1 44.2401 1 28.5C1 12.7599 13.7599 0 29.5 0ZM32.1719 30.2812C32.1719 31.7569 30.9756 32.9531 29.5 32.9531C28.0244 32.9531 26.8281 31.7569 26.8281 30.2812V14.25C26.8281 12.7744 28.0244 11.5781 29.5 11.5781C30.9756 11.5781 32.1719 12.7744 32.1719 14.25V30.2812ZM29.5 37.4062C27.5325 37.4062 25.9375 39.0012 25.9375 40.9688C25.9375 42.9363 27.5325 44.5312 29.5 44.5312C31.4675 44.5312 33.0625 42.9363 33.0625 40.9688C33.0625 39.0012 31.4675 37.4062 29.5 37.4062Z",
    fill: "#EB9700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.fa325960d9335031c9f9739f65a08676.svg";
export { ForwardRef as ReactComponent };